import React from 'react';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';
import { IndicadorEstado } from '../../ContratosCreation/components/IndicadorEstado/IndicadorEstado';

export const AdvertenciaChip = ({
    text
}) => {
    return (
        <div className='header-chip-container-gestion-periodos'>
        <div className='header-chip'>
            <div className='header-subtitle'>
                <div className='header-subtitle-icon'>
                    <IndicadorEstado onClick={null} type={'warning'}/> 
                </div>
                <strong>Advertencia: </strong>
            </div>
            <span>{text}</span>
        </div>
        </div>
    )
}